import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EtlIngestionService } from '../../../services/etl-ingestion/etl-ingestion.service';

@Component({
  selector: 'creditor-autocomplete',
  templateUrl: './creditor-autocomplete.component.html',
  styleUrl: './creditor-autocomplete.component.css'
})
export class CreditorAutocompleteComponent {
  public creditors: any | null = null;
  public selectedCreditor: any | null = null;
  public filteredCreditors: any[] = [];

  @Input() styleClass: string = '';
  @Output() onSelect = new EventEmitter<string>();

  constructor(private etlIngestionService: EtlIngestionService, ){}

  ngOnInit(){
    this.etlIngestionService.getCreditors().subscribe((res:any) => {
      if(!!res && !!res.Creditors && Array.isArray(res.Creditors) && res.Creditors.length > 0){
        this.creditors = res.Creditors;
      }   
     });
  }

  onKeyUp(event: any){
    if(!event.currentTarget.value){
      this.onSelect.emit('');
    }
  }

  onSelectCreditor(event: any){
    this.onSelect.emit(this.selectedCreditor.CreditorId)
  }

  filterCreditors(event: any) {
    let filteredItems: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.creditors as any[]).length; i++) {
        let item = (this.creditors as any[])[i];
        if (item.CreditorId.indexOf(query) !== -1
        || item.CompanyName.toLowerCase().indexOf(query.toLowerCase()) !== -1
      ) {
            filteredItems.push(item);
        }
    }

    this.filteredCreditors = filteredItems;
  }
}
